import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aqar',
  templateUrl: './aqar.component.html',
  styleUrls: ['./aqar.component.scss']
})
export class AqarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
